
        // Spend source colour map — stable colours across chart + legend
        function spendSourceColor(source) {
            const map = {
                'anthropic_classifier': '#c9a96e',  // gold
                'voyage_embeddings':    '#6fb0c8',  // blue
                'x_api':                '#a479b8',  // purple
            };
            return map[source] || '#79839a';
        }

export { spendSourceColor };
